const addLayer = (state, {layer, style, position}) => {
  if (!state.layers.has(layer.objectid)) {
    state.layers.set(layer.objectid, {
      body: layer,
      position: position,
      draft: {
        select: [],
        where: {
          attributeFilters: [],
          spatialFilters: [],
        },
        groupBy: [],
        having: [],
        orderBy: [],
        style: {
          paint: {
            circleBlur: 0,
            fillColor: '#000000',
            fillOpacity: 1,
            colorTheme: [],
            sizeTheme: [],
            symbolTheme: []
          }
        }
      },
      applied: null,
      style: style,
      visible: false
    })
  }
}
const removeLayer = (state, layerId) => {
  state.layers.delete(layerId)
}
const setActiveLayer = (state, layerId) => {
  state.activeLayerId = layerId
}
const initializeLayer = (state, layerId) => {
  if (!state.layers.has(layerId)) {
    state.layers.set(layerId, {
      body: {},
      draft: {
        select: [],
        where: {
          attributeFilters: [],
          spatialFilters: [],
        },
        groupBy: [],
        having: [],
        orderBy: []
      },
      applied: null,
      style: {
        paint: {
          circleBlur: 0,
          fillColor: '#000000',
          fillOpacity: 1,
          colorTheme: [],
          sizeTheme: [],
          symbolTheme: []
        }
      }
    })
  }
}
const setCircleBlur = (state, { layerId, circleBlur }) => {
  if (!state.layers.has(layerId)) return false
  let layer = state.layers.get(layerId)
  layer.style.paint.circleBlur = circleBlur
}
const setFillColor = (state, { layerId, fillColor }) => {
  if (!state.layers.has(layerId)) return false
  let layer = state.layers.get(layerId)
  layer.style.paint.fillColor = fillColor
}
const setFillOpacity = (state, { layerId, fillOpacity }) => {
  if (!state.layers.has(layerId)) return false
  let layer = state.layers.get(layerId)
  layer.style.paint.fillOpacity = fillOpacity
}
const setColumns = (state, columns) => {
  state.layers[state.activeLayerId].draft.select = columns;
}
const setColorTheme = (state, { layerId, colors }) => {
  if (!state.layers[layerId]) return false
  state.layers[layerId].style.paint.colorTheme = colors
}
const setFeatureLayer = (state, payload) => {
  const index = state.layersBase.findIndex(x => x.Alias === payload.Alias)
  if (index === -1) return false
  state.layersBase[index] = payload
}
const setGeoPopLevels = (state, payload) => { state.geoPopLevels = payload }
const setLayersBase = (state, payload) => { state.layersBase = payload }
const setAddLayerBase = (state, payload) => { state.layersBase.unshift(payload) }
const setNewLayer = (state, payload) => { state.newLayer = payload }
const setStatusLayer = (state, payload) => { state.statusLayer = payload }
const updateDataVis = (state, payload) => {
  const item = state.layerList.find(item => item.id === payload.id)
  const layer = item.object.layer
  layer.jbData.config.datavis = payload.datavis
}
const updateStyle = (state, payload) => {
  const item = state.layerList.find(item => item.id === payload.id)
  const layer = item.object.layer
  layer.jbData.config.datavis.style = payload.style
}
const setRemoveLayerBase = (state, payload) => {
  // state.layersBase.splice(state.layersBase.findIndex(e => e === payload), 1)
  state.layersBase.splice(state.layersBase.findIndex(e => e.layer.gdIdEvent === payload.gdIdEvent))
}
const setLoading = (state, payload) => {
  state.loading = payload
}
const setLayersMenu = (state, payload) => {
  state.layersMenu = payload
}
const setEnvironment = (state, payload) => {
  state.environment = payload
}
const setEnvironmentDataMenu = (state, menuId) => {
  state.environmentDataMenu = menuId
}
const setUploadLayers = (state, layers) => {
  state.uploadLayers = layers
}
const renameLayer = (state, { layerId, newName, isUpload }) => {
  if (isUpload) {
    const idx = state.uploadLayers.findIndex(e => e.layerId === layerId)
    if (idx !== -1) {
      state.uploadLayers[idx].name = newName
    }
  } else {
    const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
    if (idx !== -1) {
      state.layersBase[idx].Name = newName
    }
  }
}
const deleteLayer = (state, { layerId }) => {
  const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
  if (idx !== -1) state.layersBase.splice(idx, 1)
}
const removeReference = (state, { layerId }) => {
  const idx = state.layersBase.findIndex(e => e.layer.ObjectId === layerId)
  if (idx !== -1) state.layersBase.splice(idx, 1)
}
const togglePromotion = (state, { layerId, isUpload }) => {
  if (isUpload) {
    const idx = state.uploadLayers.findIndex(e => e.layerId === layerId)
    if (idx !== -1) {
      const row = state.uploadLayers[idx]
      const layer = row.object.layer
      if (!layer.jbData.config.hasOwnProperty('promoted')) layer.jbData.config.promoted = false
      layer.jbData.config.promoted = !layer.jbData.config.promoted
    }
  } else {
    const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
    if (idx !== -1) {
      state.layersBase[idx].IsPromoted = !state.layersBase[idx].IsPromoted
    }
  }
}
const toggleVisibility = (state, layerId) => {
  if (!state.layers.has(layerId)) return false
  const featureLayer = state.layers.get(layerId)
  featureLayer.visible = !featureLayer.visible
}

export default {
  addLayer,
  deleteLayer,
  initializeLayer,
  removeLayer,
  removeReference,
  renameLayer,
  setActiveLayer,
  setCircleBlur,
  setColorTheme,
  setColumns,
  setEnvironment,
  setFillColor,
  setFillOpacity,
  setEnvironmentDataMenu,
  setLayersMenu,
  setLoading,
  setGeoPopLevels,
  setLayersBase,
  setAddLayerBase,
  setRemoveLayerBase,
  setFeatureLayer,
  setNewLayer,
  setStatusLayer,
  setUploadLayers,
  togglePromotion,
  toggleVisibility,
  updateDataVis,
  updateStyle
}
